import { render, staticRenderFns } from "./IpsCreate.vue?vue&type=template&id=6146bae0"
import script from "./IpsCreate.vue?vue&type=script&lang=js"
export * from "./IpsCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports